import { apiRequest } from './client.js';

export interface PortalView {
  client: { name: string; sector: string | null };
  site: { name: string; address: string | null; criticality: string | null };
  completed_at: string | null;
  global_score: number;
  instances: {
    id: string;
    template: { code: string; name: string };
    weighted: number;
    per_domain: Record<string, number>;
  }[];
  top_findings: { domain: string; score: number }[];
}

export interface PortalTokenSummary {
  id: string;
  expires_at: string;
  revoked_at: string | null;
  created_at: string;
  last_accessed_at: string | null;
  access_count: number;
}

export interface PortalTokenCreated {
  id: string;
  token: string;
  portal_url: string;
  expires_at: string;
  created_at: string;
}

export const portalAdminApi = {
  list: (assessmentId: string) =>
    apiRequest<{ tokens: PortalTokenSummary[] }>(
      `/api/v1/assessments/${assessmentId}/portal-tokens`,
    ),
  create: (
    assessmentId: string,
    input: { expires_in_days?: number; email_to?: string; client_name?: string },
  ) =>
    apiRequest<PortalTokenCreated>(`/api/v1/assessments/${assessmentId}/portal-tokens`, {
      method: 'POST',
      body: input,
    }),
  revoke: (assessmentId: string, tokenId: string) =>
    apiRequest<void>(`/api/v1/assessments/${assessmentId}/portal-tokens/${tokenId}`, {
      method: 'DELETE',
    }),
};

/** Fetch del portal publico — NO usa apiRequest porque no debe enviar
 *  Authorization Bearer. Es una ruta sin sesion. */
export async function fetchPortalView(token: string): Promise<PortalView> {
  const res = await fetch(`/api/v1/portal/${encodeURIComponent(token)}`, {
    credentials: 'omit',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    const code = body.error ?? `http_${String(res.status)}`;
    throw new Error(`${String(res.status)}:${code}`);
  }
  return (await res.json()) as PortalView;
}

export function portalPdfUrl(token: string): string {
  return `/api/v1/portal/${encodeURIComponent(token)}/report/pdf`;
}
